module.exports = __webpack_public_path__ + "03_short_black.6e7d381c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/03_short_black.png
// module id = LiAm
// module chunks = 0